import React, { useState, useEffect } from 'react';

// "Live · Updated 4m ago" style pulse indicator, mirrors the header pattern
// on our sister TK apps.  Pass ``updatedAt`` as any parse-able date/ISO
// string.  Falls back to "Live" if no date.
export const LiveIndicator = ({ updatedAt, label = 'Live', className = '' }) => {
  const [ago, setAgo] = useState(() => humanAgo(updatedAt));
  useEffect(() => {
    setAgo(humanAgo(updatedAt));
    if (!updatedAt) return;
    const id = setInterval(() => setAgo(humanAgo(updatedAt)), 60_000);
    return () => clearInterval(id);
  }, [updatedAt]);

  return (
    <span
      data-testid="live-indicator"
      className={`inline-flex items-center gap-2 text-[11px] font-medium text-[#525252] ${className}`}
    >
      <span className="relative flex w-2 h-2">
        <span className="absolute inline-flex w-full h-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
        <span className="relative inline-flex w-2 h-2 rounded-full bg-emerald-500" />
      </span>
      <span className="font-semibold text-[#171717]">{label}</span>
      {ago && <span className="text-[#A3A3A3]">· Updated {ago}</span>}
    </span>
  );
};

function humanAgo(when) {
  if (!when) return '';
  const t = new Date(when).getTime();
  if (Number.isNaN(t)) return '';
  const diff = Math.max(0, Date.now() - t);
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const dt = new Date(when);
  return dt.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
}

export default LiveIndicator;
